import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable } from '@angular/material/table';
import { IHelpImpactElement, IHelpProbabilityElement } from 'src/app/core/models/front';
import { IHelpDataService } from 'src/app/core/services/core';

@Component({
  selector: 'howden-help-risk-map',
  templateUrl: './help-risk-map.component.html',
  styleUrls: ['./help-risk-map.component.scss'],
  imports: [
    CdkScrollable,
    MatDialogTitle,
    MatDialogContent,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class HelpRiskMapComponent {
  private helpDataSrv = inject(IHelpDataService);

  public dataSourceProbabilidad: IHelpProbabilityElement[] = [];
  public displayedColumnsProbabilidad: string[] = ['clasification', 'value', 'frequency', 'example'];
  public dataSourceImpacto: IHelpImpactElement[] = [];
  public displayedColumnsImpacto: string[] = ['clasification', 'value', 'quantification'];

  constructor() {
    this.dataSourceProbabilidad = this.helpDataSrv.getDataHelpProbability();
    this.dataSourceImpacto = this.helpDataSrv.getDataHelpImpact();
  }
}
